import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import LandingPage from "@/pages/LandingPage";
import NorthHoustonPage from "@/pages/NorthHoustonPage";
import ComparePage from "@/pages/ComparePage";
import PitchLetterPage from "@/pages/PitchLetterPage";
import PressKitPage from "@/pages/PressKitPage";
import { LanguageProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/baytown" element={<LandingPage />} />
            <Route path="/north-houston" element={<NorthHoustonPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/pitch" element={<PitchLetterPage />} />
            <Route path="/press" element={<PressKitPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A192F",
              color: "#F9F7F1",
              border: "1px solid #0A192F",
              borderRadius: "2px",
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
